import React from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { H6 } from '../../shared/theme/styles';
import './Navigation.css';
import { DesktopNavOptions } from './NavOptions/NavOptions';
import UserDropDown from './UserDropDown/UserDropDown';
import { isMobile, shouldBeMobile, clearDesktopMode } from '../../shared/utils/MobileDetector/MobileDetector';
import { translate } from '../../shared/translations';
import { testID } from '../../shared/utils/integrationTesting/integrationTesting';
import { navTestId } from '../../constants/testIds';
import { fetchNavOptionsAction } from '../../actions/actionCreators';
import { fetchUserInfoAction } from '../../shared/actions/actionCreators';

const companyLogo = (
    <img
        {...testID(navTestId.companyLogo)}
        className="companyLogo"
        src="/main/images/icons/movista-logo_rebrand.png"
        alt="Company Logo"
        width="px"
        height="32px"
    />
);

function handleBackToMobile() {
    clearDesktopMode();
    window.dispatchEvent(new Event('resize'));
}

export const RightGroup = (props) => (
    props.isMobile ? null : <UserDropDown />
);

export const LeftGroup = (props) => {
    const MobileLeftGroup = () => (<UserDropDown isMobile />);
    const DesktopLeftGroup = () => (
        <>
            {companyLogo}
            <DesktopNavOptions />
        </>
    );

    return props.isMobile ? (<MobileLeftGroup />) : (<DesktopLeftGroup />);
};

export const Footer = (props) => ((!props.isMobile && shouldBeMobile()) ? (
    <div className="go-to-mobile" role="link" tabIndex="0" onClick={() => handleBackToMobile()}>
        {translate('go_to_mobile_site')}
    </div>
) : null);

export class Navigation extends React.Component {
    debouncedResize = debounce(() => {
        if (!isMobile()) {
            // this is never something we want do do unthrottled.
            this.forceUpdate();
        }
    }, 100);

    componentDidMount() {
        this.props.getNavOptions();
        this.props.getUserInfo();
        window.addEventListener('resize', this.debouncedResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedResize);
    }

    render() {
        return (
            <div className="header" style={H6}>
                <LeftGroup isMobile={this.props.isMobile} />
                <div className="spacer" />
                <RightGroup isMobile={this.props.isMobile} />
                <Footer isMobile={this.props.isMobile} />
            </div>
        );
    }
}

/* istanbul ignore next */
const mapStateToProps = (state) => ({
    languages: state.userInfo.availableLanguages,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    getNavOptions: () => {
        dispatch(fetchNavOptionsAction());
    },
    getUserInfo: () => {
        dispatch(fetchUserInfoAction());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
